import React from "react";
import IntroSection from "../components/IntroSection";
import ScopingSolution from "../components/ScopingSolution";
import MVPprocess from "../components/MVPprocess";
import CustomerTestimonials from "../components/CustomerTestimonials";
import MVPbenefits from "../components/MVPbenefits";
import MVPaward from "../components/MVPaward";
import BlueSectionDivider from "../components/BlueSectionDivider";
import CountriesSection from "../components/CountriesSection";
import TeamSection from "../components/TeamSection";
import WhyUsSection from "../components/WhyUsSection";
import WorkingModelSection from "../components/WorkingModelSection";
import TechStackSection from "../components/TechStackSection";
import MVPfaq from "../components/MVPfaq";
import MVPresources from "../components/MVPresources";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const MinimumViable = () =>{
    return(
        <div>
            <IntroSection title = "Minimum Viable Product" paragraph = "We bring your product idea to life by prototyping a well-built MVP."  backgroundImage="/images/mvp-bg.webp"/>
            <ScopingSolution para1 = "Our expertise covers an array of areas, from simpler projects such as website building to highly complex web based applications." para2 = "Our MVP in software provides you with the right tools and resources to guide you through the process of building a first prototype of your idea."/>
            <MVPprocess/>
            
            <MVPbenefits/>
            
            <BlueSectionDivider/>
            <CountriesSection/>
            <BlueSectionDivider/>
            <TeamSection/>
            <WhyUsSection/>
            <WorkingModelSection/>
            <TechStackSection/>
            <BlueSectionDivider/>
            <MVPfaq/>
          
           <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>
        </div>
    )
}
export  default MinimumViable;